import apiClient from './index';
import config from '../config';
import {
  AskLioChatRequest,
  AskLioFeedbackModel,
} from '../types/ask-lio/askLioTypes';

const baseUrl = `/${config.API_VERSION}/aiintegration/`;

// Other client management functions can be added similarly...
const askLioEndpoint = (path: string) => `${baseUrl}asklio${path}`;

export const sendAskLioQurey = (data: AskLioChatRequest) => {
  return apiClient.post(askLioEndpoint('/chat'), data);
};

/* ASK LIO */
export const submitAskLioFeedback = (feedback: AskLioFeedbackModel) => {
  return apiClient.post(askLioEndpoint(`/feedback`), feedback);
};

export const getSuggestedQuestionList = (entity: string, task: string) => {
  return apiClient.get(askLioEndpoint(`/questions/${entity}/${task}`));
};
export const downloadDocument = (knowledgeBase: string, fileName: string) => {
  return apiClient.get(
    askLioEndpoint(`/knowledgebase/${knowledgeBase}/document/${fileName}`),
    {
      responseType: 'blob',
    }
  );
};
